import { Framework } from '@vfpf/framework';
import { GegevensWerknemerDto } from '../../api';
import { FormulierProcessDependencies } from './dependencies';
import { setIsComplete, submitPreadviesFormulier, submitToestemmingsverklaring, getFormulierenUser, addToCsv, setIsLoading } from './methods';
import { PreAdviesFormulierFormData } from './state';

export type FormulierMethods = {
  submitPreadviesFormulier: (values: PreAdviesFormulierFormData, fileName: string) => Promise<number>;
  submitToestemmingsverklaring: (values: PreAdviesFormulierFormData, file: File, fileName: string, dossierId: number) => Promise<void>;
  getFormulierenUser: () => Promise<void>;
  setIsComplete: (value: boolean) => Promise<void>;
  setIsLoading: (value: boolean) => Promise<void>;
  addToCsv: (values: GegevensWerknemerDto) => Promise<void>;
};

export const formulierProcessCreator: Framework.ProcessCreator<FormulierMethods> = (
  deps: FormulierProcessDependencies
) => ({
  submitPreadviesFormulier: (values, fileName) => submitPreadviesFormulier(values, fileName, deps),
  submitToestemmingsverklaring: (values, file, fileName, dossierId) => submitToestemmingsverklaring(values, file, fileName, dossierId, deps),
  getFormulierenUser: () => getFormulierenUser(deps),
  setIsComplete: value => setIsComplete(value, deps),
  setIsLoading: value => setIsLoading(value, deps),
  addToCsv: (values) => addToCsv(values, deps),
});
